import React from 'react';

import CalendarIcon from 'Assets/icons/blank-calendar.svg';

// The event has no milestones flagged for the roadmap at all; points the user at where they come
// from (the Project Plan).
const RoadmapEmptyState = () => {
    return (
        <div className="tw-flex tw-flex-col tw-items-center tw-justify-center tw-text-center tw-px-6 tw-py-16">
            <div className="tw-flex tw-items-center tw-justify-center tw-h-14 tw-w-14 tw-rounded-full tw-bg-background tw-mb-4">
                <CalendarIcon className="tw-h-6 tw-w-6 tw-text-charcoal-50" aria-hidden="true" />
            </div>
            <h4 className="tw-text-base tw-font-semibold tw-text-charcoal tw-mb-1">{$t('No milestones to show')}</h4>
            <p className="tw-text-sm tw-text-charcoal-75 tw-max-w-sm">
                {$t('Milestones appear here once activities with a target date are added in the Project Plan.')}
            </p>
        </div>
    );
};

export default RoadmapEmptyState;
